'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var Scrollbar = _interopDefault(require('smooth-scrollbar'));

var version = "0.0.0";

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};











var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};











var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var Component = videojs.getComponent('Component');

var CommentInput = function (_Component) {
  inherits(CommentInput, _Component);

  function CommentInput(player, options) {
    classCallCheck(this, CommentInput);

    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    _this._initEventListener(_this);
    return _this;
  }

  CommentInput.prototype.createEl = function createEl() {
    return videojs.dom.createEl('textarea', {
      id: 'vjs-comment-input',
      className: 'vjs-comment-input form-control form-group',
      placeholder: 'Votre commentaire',
      rows: '4'
    });
  };

  CommentInput.prototype.emptyValue = function emptyValue() {
    this.el_.value = "";
  };

  CommentInput.prototype._initEventListener = function _initEventListener(input) {
    document.addEventListener('mousedown', function (e) {
      if (e.target && e.target.id === 'vjs-comment-input') {
        handleFocus();
      }
    });

    function handleFocus() {
      if (input.hasClass('vjs-comment-input-error')) {
        input.removeClass('vjs-comment-input-error');
        input.el_.value = "";
      }
    }
  };

  CommentInput.prototype.valueIsEmpty = function valueIsEmpty() {
    this.addClass('vjs-comment-input-error');
    this.el_.value = "Veuillez saisir votre commentaire";
  };

  CommentInput.prototype.isEmpty = function isEmpty() {
    return this.el_.value === "" || this.hasClass('vjs-comment-input-error');
  };

  return CommentInput;
}(Component);

var Component$1 = videojs.getComponent('Component');

var NameInput = function (_Component) {
  inherits(NameInput, _Component);

  function NameInput(player, options) {
    classCallCheck(this, NameInput);

    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    _this._initEventListener(_this);
    return _this;
  }

  NameInput.prototype.createEl = function createEl() {
    return videojs.dom.createEl('input', {
      id: 'vjs-name-input',
      className: 'vjs-name-input  form-control form-group',
      placeholder: 'Votre nom'
    });
  };

  NameInput.prototype.emptyValue = function emptyValue() {
    this.el_.value = "";
  };

  NameInput.prototype._initEventListener = function _initEventListener(input) {
    document.addEventListener('mousedown', function (e) {
      if (e.target && e.target.id === 'vjs-name-input') {
        handleFocus();
      }
    });

    function handleFocus() {
      if (input.hasClass('vjs-name-input-error')) {
        input.removeClass('vjs-name-input-error');
        input.el_.value = "";
      }
    }
  };

  NameInput.prototype.valueIsEmpty = function valueIsEmpty() {
    this.addClass('vjs-name-input-error');
    this.el_.value = "Veuillez préciser votre nom";
  };

  NameInput.prototype.isEmpty = function isEmpty() {
    return this.el_.value === "" || this.hasClass('vjs-name-input-error');
  };

  return NameInput;
}(Component$1);

var Component$2 = videojs.getComponent('Button');

var CommentButton = function (_Component) {
  inherits(CommentButton, _Component);

  function CommentButton(player, options) {
    classCallCheck(this, CommentButton);

    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    _this.addClass('vjs-submit-comment-button');
    _this.controlText("Commenter");
    _this.content();
    _this.parent = options;
    return _this;
  }

  CommentButton.prototype.content = function content() {
    videojs.dom.emptyEl(this.el());
    videojs.dom.appendContent(this.el(), "Commenter");
  };

  CommentButton.prototype.handleClick = function handleClick() {
    this.parent.addComment();
  };

  return CommentButton;
}(Component$2);

var Component$5 = videojs.getComponent('Component');
var CommentField = videojs.getComponent('CommentField');

var optionsScroll$1 = {
  damping: 0.1,
  thumbMinSize: 20,
  renderByPixels: !('ontouchstart' in document),
  alwaysShowTracks: true,
  continuousScrolling: true
};

var CommentContainer$1 = function (_Component) {
  inherits(CommentContainer, _Component);

  function CommentContainer(player, options) {
    classCallCheck(this, CommentContainer);

    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    _this.player = player;
    _this.options = options;
    _this.comments = options.comments;
    _this._content();
    _this.on("addingComment", _this.triggerAddComment);
    return _this;
  }

  CommentContainer.prototype.createEl = function createEl() {
    return videojs.dom.createEl('div', {
      id: 'vjs-comment-container',
      className: 'vjs-comment-container'
    });
  };

  CommentContainer.prototype._content = function _content() {
    if (this.comments) {
      for (var i = 0; i < this.comments.length; i++) {
        var commentField = this.addChild('CommentField', CommentField);
        commentField._content(this.comments[i]);
        this.el_.scrollTop = this.el_.scrollHeight;
      }
    }
  };

  CommentContainer.prototype.triggerAddComment = function triggerAddComment(event, data) {
    var s = Scrollbar.init(document.querySelector('#comment-container-scroll'), optionsScroll$1);
    window.scrollBarComment = s;
    var commentField = this.addChild('CommentField', CommentField);
    commentField._content(data);
    this.el_.scrollTop = this.el_.scrollHeight;
  };

  return CommentContainer;
}(Component$5);

var Component$4 = videojs.getComponent('Component');

var CommentContainerScroll = function (_Component) {
  inherits(CommentContainerScroll, _Component);

  function CommentContainerScroll(player, options) {
    classCallCheck(this, CommentContainerScroll);

    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    _this.addChild('CommentContainer', options);
    return _this;
  }

  CommentContainerScroll.prototype.createEl = function createEl() {
    return videojs.dom.createEl('div', {
      id: 'comment-container-scroll',
      className: 'vjs-comment-container-scroll'
    });
  };

  return CommentContainerScroll;
}(Component$4);

function formatDate(date) {
  var today = new Date(date);
  var dd = today.getDate();
  var mm = today.getMonth() + 1; //January is 0!

  var yyyy = today.getFullYear();
  if (dd < 10) {
    dd = '0' + dd;
  }
  if (mm < 10) {
    mm = '0' + mm;
  }
  var today = dd + '-' + mm + '-' + yyyy;
  return today;
}
function formatAnswer(comment) {
  var response = {};
  response.id = comment.id;
  response.date = formatDate(comment.date);
  response.value = comment.comment;
  response.user = comment.user;
  return response;
}

function sendData(comment, name, player) {
  var HTTP = commentsPlayer.commentsOptions.api.api_post_comment.HTTP;
  var URL = commentsPlayer.commentsOptions.api.api_post_comment.URL;
  var mediaId = commentsPlayer.commentsOptions.api.api_post_comment.mediaId;
  var client = commentsPlayer.commentsOptions.api.api_post_comment.client;

  var params = { empMediaCommentsForm: {
      "comment": comment,
      "email": name,
      "media": parseInt(mediaId)
    },
    client: client };

  HTTP.post(URL, params, {
    emulateJSON: true
  }).then(function (response) {
    if (response.data.code === 200) {}
  }, function (response) {
    console.log('api error');
    player.trigger('error', { code: response.code, cause: response.message });
  });
}
function getData(player) {
  var HTTP = commentsPlayer.commentsOptions.api.api_list_comment.HTTP;
  var URL = commentsPlayer.commentsOptions.api.api_list_comment.URL;
  var client = commentsPlayer.commentsOptions.api.api_list_comment.client;

  HTTP.get(URL, { params: { client: client } }).then(function (response) {
    if (response.data.code === 200 && response.data && response.data.data) {
      var comments = response.data.data[0].comments;
      for (var i = 0; i < comments.length; i++) {
        commentsPlayer.getChild('NavigationContainer').getChild('NavigationContent').getChild('Comments').getChild('CommentContainerScroll').getChild('CommentContainer').trigger({ type: "addingComment" }, formatAnswer(comments[i]));
      }
    }
  }, function (response) {
    console.log('api error');
    player.trigger('error', { code: response.code, cause: response.message });
  });
}

var Component$3 = videojs.getComponent('Component');
var CommentInputContainer = videojs.getComponent('CommentInputContainer');
var CommentContainer = videojs.getComponent('CommentContainer');

var optionsScroll = {
  damping: 0.1,
  thumbMinSize: 20,
  renderByPixels: !('ontouchstart' in document),
  alwaysShowTracks: true,
  continuousScrolling: true
};

var Comments = function (_Component) {
  inherits(Comments, _Component);

  function Comments(player, options) {
    classCallCheck(this, Comments);

    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    _this.options = options;
    _this.player = player;
    _this._createContent();
    _this.getComment();
    return _this;
  }

  Comments.prototype.createEl = function createEl() {
    return videojs.dom.createEl('div', {
      className: 'vjs-comments'
    });
  };

  Comments.prototype._createContent = function _createContent() {
    this.addChild('CommentInputContainer', this);
    this.addChild('CommentContainerScroll', this.options);
  };

  Comments.prototype.addComment = function addComment() {
    var input = this.getChild('CommentInputContainer').getChild('CommentInput');
    var name = this.getChild('CommentInputContainer').getChild('NameInput');
    if (input.isEmpty() || name.isEmpty()) {
      if (input.isEmpty()) {
        this.getChild('CommentInputContainer').getChild('CommentInput').valueIsEmpty();
      }
      if (name.isEmpty()) {
        this.getChild('CommentInputContainer').getChild('NameInput').valueIsEmpty();
      }
    } else {
      sendData(input.el_.value, name.el_.value, this.player);
      this.getChild('CommentContainerScroll').getChild('CommentContainer').trigger({ type: "addingComment" }, {
        id: "44",
        user: name.el_.value,
        value: input.el_.value,
        date: getDate()
      });
      this.getChild('CommentInputContainer').getChild('NameInput').emptyValue();
      this.getChild('CommentInputContainer').getChild('CommentInput').emptyValue();
      if (typeof window.scrollBarComment === "undefined") {
        var s = Scrollbar.init(document.querySelector('#comment-container-scroll'), optionsScroll);
        window.scrollBarComment = s;
      }
    }

    function getDate() {
      var today = new Date();
      var dd = today.getDate();
      var mm = today.getMonth() + 1; //January is 0!

      var yyyy = today.getFullYear();
      if (dd < 10) {
        dd = '0' + dd;
      }
      if (mm < 10) {
        mm = '0' + mm;
      }
      var today = dd + '-' + mm + '-' + yyyy;
      return today;
    }
  };

  Comments.prototype.getComment = function getComment() {
    getData(this.player);
  };

  return Comments;
}(Component$3);

var Component$6 = videojs.getComponent('Component');

var CommentMessage = function (_Component) {
  inherits(CommentMessage, _Component);

  function CommentMessage(player, options) {
    classCallCheck(this, CommentMessage);

    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    _this._content();
    return _this;
  }

  CommentMessage.prototype.createEl = function createEl() {
    return videojs.dom.createEl('div', {
      className: 'vjs-comment-message'
    });
  };

  CommentMessage.prototype._content = function _content() {
    this.el_.id = 'vjs-comment-message';
    var commentBuild = '\n      <span>\n      Commentaires\n      </span>';
    this.el_.innerHTML = commentBuild;
  };

  return CommentMessage;
}(Component$6);

var Component$7 = videojs.getComponent('Component');
var CommentMessage$2 = videojs.getComponent('CommentMessage');
var NameInput$2 = videojs.getComponent('NameInput');
var CommentInput$2 = videojs.getComponent('CommentInput');
var CommentActionContainer = videojs.getComponent('CommentActionContainer');

var CommentInputContainer$1 = function (_Component) {
  inherits(CommentInputContainer, _Component);

  function CommentInputContainer(player, options) {
    classCallCheck(this, CommentInputContainer);

    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    _this.player = player;
    _this.options = options;
    _this._content();
    return _this;
  }

  CommentInputContainer.prototype.createEl = function createEl() {
    return videojs.dom.createEl('div', {
      id: 'vjs-comment-input-container',
      className: 'vjs-comment-input-container'
    });
  };

  CommentInputContainer.prototype._content = function _content() {
    this.addChild('CommentMessage', CommentMessage$2);
    this.addChild('NameInput', NameInput$2);
    this.addChild('CommentInput', CommentInput$2);
    this.addChild('CommentActionContainer', this.options);
  };

  return CommentInputContainer;
}(Component$7);

var Component$8 = videojs.getComponent('Component');

var CommentField$1 = function (_Component) {
  inherits(CommentField, _Component);

  function CommentField(player, options) {
    classCallCheck(this, CommentField);
    return possibleConstructorReturn(this, _Component.call(this, player, options));
  }

  CommentField.prototype.createEl = function createEl() {
    return videojs.dom.createEl('div', {
      className: 'vjs-comment-field'
    });
  };

  CommentField.prototype._content = function _content(comment) {
    this.el_.id = 'vjs-comment-field-' + comment.id;
    var commentBuild = '\n      <div class="vjs-comment-field-user">\n          ' + comment.user + '\n      </div>\n      <div class="vjs-comment-field-content">\n          <p>' + comment.value + '</p>\n          <div class="vjs-comment-field-date" >\n          ' + comment.date + '\n        </div>\n      </div>\n    ';
    this.el_.innerHTML = commentBuild;
  };

  return CommentField;
}(Component$8);

var Component$9 = videojs.getComponent('Button');

var CancelButton = function (_Component) {
  inherits(CancelButton, _Component);

  function CancelButton(player, options) {
    classCallCheck(this, CancelButton);

    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    _this.addClass('vjs-cancel-comment-button');
    _this.controlText("Annuler");
    _this.content();
    _this.parent = options;
    _this.player = player;
    return _this;
  }

  CancelButton.prototype.content = function content() {
    videojs.dom.emptyEl(this.el());
    videojs.dom.appendContent(this.el(), "Annuler");
  };

  CancelButton.prototype.handleClick = function handleClick() {
    if (this.player.getChild('NavigationContainer').hasClass('vjs-navigation-container-show')) {
      this.player.getChild('NavigationContainer').closeNavigation("btn_close");
    }
  };

  return CancelButton;
}(Component$9);

var Component$10 = videojs.getComponent('Component');

var CommentButton$2 = videojs.getComponent('CommentButton');
var CancelButton$2 = videojs.getComponent('CancelButton');

var CommentActionContainer$1 = function (_Component) {
  inherits(CommentActionContainer, _Component);

  function CommentActionContainer(player, options) {
    classCallCheck(this, CommentActionContainer);

    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    _this.addChild('CancelButton', options);
    _this.addChild('CommentButton', options);
    return _this;
  }

  CommentActionContainer.prototype.createEl = function createEl() {
    return videojs.dom.createEl('div', {
      id: 'vjs-comment-action-container',
      className: 'vjs-comment-action-container'
    });
  };

  return CommentActionContainer;
}(Component$10);

// Default options for the plugin.
var defaults = {};

// Cross-compatibility for Video.js 5 and 6.
var registerPlugin = videojs.registerPlugin || videojs.plugin;
// const dom = videojs.dom || videojs;

/**
 * Function to invoke when the player is ready.
 *
 * This is a great place for your plugin to initialize itself. When this
 * function is called, the player will have its DOM and child components
 * in place.
 *
 * @function onPlayerReady
 * @param    {Player} player
 *           A Video.js player object.
 *
 * @param    {Object} [options={}]
 *           A plain object containing options for the plugin.
 */

videojs.registerComponent('Comments', Comments);
videojs.registerComponent('CommentContainer', CommentContainer$1);
videojs.registerComponent('CommentInputContainer', CommentInputContainer$1);
videojs.registerComponent('CommentField', CommentField$1);
videojs.registerComponent('CommentInput', CommentInput);
videojs.registerComponent('NameInput', NameInput);
videojs.registerComponent('CommentMessage', CommentMessage);
videojs.registerComponent('CommentButton', CommentButton);
videojs.registerComponent('CancelButton', CancelButton);
videojs.registerComponent('CommentActionContainer', CommentActionContainer$1);
videojs.registerComponent('CommentContainerScroll', CommentContainerScroll);

var onPlayerReady = function onPlayerReady(player, options) {
  window.commentsPlayer = player;
  videojs.getComponent('Player').prototype.commentsOptions = options;
};

/**
 * A video.js plugin.
 *
 * In the plugin function, the value of `this` is a video.js `Player`
 * instance. You cannot rely on the player being in a "ready" state here,
 * depending on how the plugin is invoked. This may or may not be important
 * to you; if not, remove the wait for "ready"!
 *
 * @function comments
 * @param    {Object} [options={}]
 *           An object of options left to the plugin author to define.
 */
var comments = function comments(options) {
  onPlayerReady(this, videojs.mergeOptions(defaults, options));
};

// Register the plugin with video.js.
registerPlugin('comments', comments);

// Include the version number.
comments.VERSION = version;

module.exports = comments;



//////////////////
// WEBPACK FOOTER
// ./plugin/videojs_comments/dist/videojs-comments.cjs.js
// module id = 554
// module chunks = 1